// @owner ClientPlatform

import {styled} from 'styled-components';
import {cardStyles} from '../common/components/card';
import {textStyleMixin} from '../common/components/text';

export const StyledThirdPartySigninRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledForm = styled.form`
  ${cardStyles}

  background-color: var(--color-bg-surface-highlight);

  text-align: center;

  p {
    ${textStyleMixin({$variant: 'body-regular', $color: 'secondary'})}
  }

  @media (max-width: 480px) {
    width: 100%;
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 0;
    box-shadow: none;
  }
`;

export const StyledButtonIcon = styled.img`
  width: 18px;
  height: 18px;
`;

export const StyledSeparator = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  ${textStyleMixin({$variant: 'caption-regular', $color: 'tertiary'})}
  height: 16px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--color-border-alpha);
  }
`;

export const StyledFieldsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
